export const getFanclubSubscribersRoute = () => '/membership';
export const getFanclubSubscriberEditRoute = (membershipId = null) => '/membership/edit/' + (membershipId ?? ':membershipUser');
